import { Link } from 'react-router-dom';
import React from 'react';
import { isBoolean } from 'lodash';
import { FormattedMessage } from 'react-intl';
import { DEFAULT_DATE_FORMAT_TIMEZONE, DEFAULT_DATE_TIMEZONE } from 'common';
import moment from 'moment-timezone';
import messages from './messages';

// make a react-router link to the details page for a given id
const id = (uuid) => <Link to={{ pathname: `/details/${uuid}`, state: { prevPath: '/search' } }}>{uuid}</Link>;

const formatDisbursement = (isFullDisbursement) => {
  if (isBoolean(isFullDisbursement)) {
    return isFullDisbursement ? <FormattedMessage {...messages.full} />
      : <FormattedMessage {...messages.partial} />;
  }
  return '';
};

const createdDate = (val='') => {
  const dt = moment.tz(val, DEFAULT_DATE_FORMAT_TIMEZONE, DEFAULT_DATE_TIMEZONE);
  if (!dt.isValid()){
    return val;
  }
  return dt.format(DEFAULT_DATE_FORMAT_TIMEZONE);
};

const optionSorter = (a, b) => a.label.localeCompare(b.label);

const makeOptions = (values, formatter=(val) => val, sort=true) => {
  const options = values.map(
    (value) => ({ value: String(value), label: formatter(value) })
  );
  return sort ? options.sort(optionSorter): options;
};

const createdOnFilter = (key, value) => (datum) =>
  (createdDate(datum[key]).toLowerCase().lastIndexOf(value, 0) === 0);

export default {
  id,
  formatDisbursement,
  createdDate,
  makeOptions,
  createdOnFilter,
};



// WEBPACK FOOTER //
// ./src/components/SearchResultsTable/formatters.js